import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { PreciseFPContactSyncSettings } from './PreciseFPContactSyncSettings'

export const PreciseFPSpecificSettings = (): ClickNavigationSection[] => {
  return [{ id: 'contactSync', label: 'Contact Sync', content: () => <PreciseFPContactSyncSettings /> }]
}
